/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/

import React from "react";
import { Link } from "react-router-dom";
// Framer Motion
import { motion } from "framer-motion";
// BASE Components
import BASESvgIcon from "../../../@BASE/core/BASESvgIcon";
// Material-UI
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

function ExportHeader(props) {
  const {title, resource, back} = props;

  return (
    <div className="p-24 sm:p-32 sm:py-64 w-full print:hidden">
      <motion.div
        initial={{ x: 20, opacity: 0 }}
        animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
        className="flex items-center"
      >
        <Typography
          className="flex items-center"
          component={Link}
          role="button"
          to={`/${resource}`}
          color="inherit"
        >
          <BASESvgIcon size={20}>heroicons-outline:arrow-sm-left</BASESvgIcon>
          <span className="flex mx-4 font-medium capitalize">{back}</span>
        </Typography>
      </motion.div>
      <div className="flex flex-col md:flex-row md:items-center">
        <motion.div
          className="grow"
          initial={{ x: -20, opacity: 0 }}
          animate={{ x: 0, opacity: 1, transition: { delay: 0.3 } }}
        >
          <div className="flex items-center mb-8">
            <Typography className="text-20 md:text-24 font-semibold">
              {title}
            </Typography>
          </div>
        </motion.div>
        <motion.div
          className="flex-none"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0, transition: { delay: 0.2 } }}
        >
          <Button
            className="ml-8"
            variant="contained"
            onClick={() => {
              print();
              return false;
            }}
            sx={{
              backgroundColor: 'common.white',
              color: 'primary.dark',
            }}
          >
            <BASESvgIcon size={20}>heroicons-outline:printer</BASESvgIcon>
            <span className="mx-8">Print</span>
          </Button>
        </motion.div>
      </div>
    </div>
  );
}

export default ExportHeader;
